import moment from 'moment'

export const customerGroups = state => {
  let temps = []

  state.groups.forEach(g => {
    temps.push({
      id: g.id,
      label: g.name
    })
  })
  return temps
}

export const customerGreetings = state => {
  let temps = []
  let data = state.listCustomerGreetings

  if (Array.isArray(data) && data.length) {
    data.forEach(g => {
      temps.push({
        id: g.id,
        label: g.name
      })
    })
  }
  return temps
}

export const customerRatings = state => {
  let temps = []
  let data = state.listCustomerRatings

  if (Array.isArray(data) && data.length) {
    data.forEach(g => {
      temps.push({
        id: g.id,
        label: g.name
      })
    })
  }
  return temps
}

export const customerTypes = state => {
  let temps = []
  let data = state.listCustomerTypes

  if (Array.isArray(data) && data.length) {
    data.forEach(g => {
      temps.push({
        id: g.id,
        label: g.name
      })
    })
  }
  return temps
}

export const customerCategory = state => {
  let temps = []
  let data = state.customerCategories

  if (Array.isArray(data) && data.length) {
    data.forEach(g => {
      temps.push({
        id: g.id,
        label: g.name
      })
    })
  }
  return temps
}

export const customerSegment = state => {
  let temps = []
  let data = state.customerSegments

  if (Array.isArray(data) && data.length) {
    data.forEach(g => {
      temps.push({
        id: g.id,
        label: g.name
      })
    })
  }
  return temps
}

export const customerOwnership = state => {
  let temps = []
  let data = state.customerOwnerships

  if (Array.isArray(data) && data.length) {
    data.forEach(g => {
      temps.push({
        id: g.id,
        label: g.name
      })
    })
  }
  return temps
}

export const contactTitle = state => {
  let temps = []
  let data = state.titles

  if (Array.isArray(data) && data.length) {
    data.forEach(g => {
      temps.push({
        id: g.id,
        label: g.name
      })
    })
  }
  return temps
}
export const setTable = val => {
  let quarter = ['Q1 ', 'Q2 ', 'Q3 ', 'Q4 ']
  let startYear = moment(val.pbFirst).format('YYYY')
  let endYear = moment(val.pbLast).format('YYYY')
  let now = parseInt(moment().format('YYYY'))
  let ey = parseInt(endYear)

  let start = parseInt(startYear)
  let end = ey > now ? ey : now
  let yearRange = end - start

  let temps = []
  let months = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]
  let tempMonth = []

  if (start == end) {
    quarter.forEach(q => {
      temps.push(q + startYear)
    })

    months.forEach(m => {
      tempMonth.push({
        id: m,
        year: start
      })
    })
  } else {
    for (let i = 0; i <= yearRange; i++) {
      let year = start + i
      quarter.forEach(q => {
        temps.push(q + year)
      })

      months.forEach(m => {
        tempMonth.push({
          id: m,
          year: year
        })
      })
    }
  }

  return {
    years: temps,
    months: tempMonth
  }
}

export const getProject = state => {
  let data = state.projects
  let tProbs = []
  let temps = []
  let risks = []
  let noTemps = []
  let dones = []

  let pbFirst = null
  let pbLast = null

  let now = moment()

  let notProgress = [1, 7, 8]

  if (Array.isArray(data) && data.length) {
    data.forEach(g => {
      if (g.probabilities.length > 0) {
        if (!notProgress.includes(g.probability_id)) {
          tProbs = tProbs.concat(g.probabilities)
          let dif = moment(g.est_close)
          if (dif.diff(now, 'months') >= 1) temps.push(g)
          else risks.push(g)
        }

        if (g.probability_id == 7) dones.push(g)

        if ([1, 8].includes(g.probability_id)) risks.push(g)
      } else {
        noTemps.push(g)
      }
    })

    if (Array.isArray(tProbs) && tProbs.length) {
      tProbs.sort((a, b) => a.created - b.created)
      pbFirst = tProbs[0].created
    }

    let pl = data.sort((a, b) => b.est_close - a.est_close)

    pbLast = pl[pl.length - 1].est_close
  }

  let table = setTable({
    pbFirst: pbFirst,
    pbLast: pbLast
  })

  return {
    ongoing: temps,
    risks: risks,
    nodata: noTemps,
    dones: dones,
    years: table.years,
    months: table.months
  }
}

export const pbKanban = state => {
  let data = state.projects

  let temp = {
    plans: [],
    losts: [],
    news: [],
    smis: [],
    forecasts: [],
    deals: [],
    pos: [],
    dones: [],
    cancels: []
  }

  if (Array.isArray(data) && data.length) {
    data.forEach(d => {
      if (d.probability_id) {
        if (d.probability_id == 1) temp.losts.push(d)
        if (d.probability_id == 2) temp.news.push(d)
        if (d.probability_id == 3) temp.smis.push(d)
        if (d.probability_id == 4) temp.forecasts.push(d)
        if (d.probability_id == 5) temp.deals.push(d)
        if (d.probability_id == 6) temp.pos.push(d)
        if (d.probability_id == 7) temp.dones.push(d)
        if (d.probability_id == 8) temp.cancels.push(d)
      } else temp.plans.push(d)
    })

    return temp
  }
}
